import React, {Component} from 'react';
import {SlideDown} from 'react-slidedown';
import 'react-slidedown/lib/slidedown.css';
import moment from 'moment';
import userImage from '../../assets/img/128x128.jpg';
import api from '../../utils/api';

class VideoDiscussion extends Component {

    constructor(props){
        super(props);

        this.state = {
            openCommentId: '',
            content: '',
            questionType: '',
            replyContent: '',
            filter: [],
            discussion: [],
            sortOrder: 'newestFirst',
            questionTypeFilter: '',
            types: {
                Rudimentary: "is unclear about the lecture",
                Conceptual: "is unclear about a concept",
                Advanced: "is unclear about the application of a concept",
                General: "has a general question"
            },
            questionError: false,
            questionTypeError: false

        };

    }
    
    
    renderUserImage = (profile) => {
        if(profile){
            if(profile.image){
                return api.makeFileURL(profile.image, this.props.user.id);
            }else{
                return userImage;
            }
        }else{
            return userImage;
        }
    }
    
    typeFilter = (f) => {
        let {discussion} = this.state;
        let newDiscussion = this.props.discussion;
        
        if(f && this.props.discussion.length > 0){
            newDiscussion = JSON.parse(JSON.stringify(newDiscussion)).filter(d => d.questionType === f);
        }
        this.setState({
            discussion: newDiscussion,
            questionTypeFilter: f
        })
    }
    
    

    filterDiscussion = (newFilter, action) => {
        let {discussion, filter} = this.state;
        let newDiscussion = this.props.discussion;

        if(filter.indexOf(newFilter) > -1){
            filter = filter.splice(filter.indexOf(newFilter) + 1, 1);
        }else{
            filter.push(newFilter);
        }

        if(filter.indexOf("mine") > -1){
            newDiscussion = newDiscussion.filter(d => d.profileId == this.props.user.user.Profile.id);
        }

        if(filter.indexOf("nocomments") > -1){
            newDiscussion = newDiscussion.filter(d => d.DiscussionComment.length == 0);
        }

        if(filter.indexOf("instructor") > -1){
            newDiscussion = newDiscussion.filter(d => d.Profile.role == "instructor");
        }

        this.setState({
            discussion: newDiscussion,
            filter: filter
        })
    }

    componentDidUpdate(props){
        if(props.discussion != this.props.discussion){
            this.setState({discussion: this.props.discussion});
        }
    }
    
    componentDidMount(){

        this.setState({discussion: this.props.discussion});
        
    }

    postComment = () => {
        let discussion = {
            content: this.state.replyContent,
            created: new Date(),
            profileId: this.props.user.user.Profile.id,
            likes: [],
            chapterVideoId: this.props.chapterVideoId,
            videoDiscussionId: this.state.openCommentId
        }

        this.props.onPostComment(discussion);
    }

    postDiscussion = () => {
        let discussion = {
            content: this.state.content,
            created: new Date(),
            profileId: this.props.user.user.Profile.id,
            questionType: this.state.questionType,
            likes: [],
            chapterVideoId: this.props.chapterVideoId
        }

        if(!this.state.content){
            this.setState({questionError: true});
        }
        
        if(!this.state.questionType){
            this.setState({questionTypeError: true});
        }
        
        if(this.state.questionType && this.state.content){
            this.props.onPost(discussion);
            
            this.setState({
                content: '',
                questionType: '',
                questionError: false,
                questionTypeError: false
            })
        }
    }

    postLike = (commentId) => {


        let like = {profileId: this.props.user.user.Profile.id, videoDiscussionId: commentId};
        this.props.postLike(like);
    }

    postFollow = (commentId) => {
        let follow = {profileId: this.props.user.user.Profile.id, videoDiscussionId: commentId};
        this.props.postFollow(follow);
    }

    openComments = (id) => {
        if (id === this.state.openCommentId) {
            this.setState ({
                openCommentId: ''
            })
        } else {
            this.setState ({
                openCommentId: id
            })
        }
    };
    
    renderCommentQuestions = () => {
        let {discussion, sortOrder} = this.state;
        
        if(this.state.discussion.length > 0){
        return this.state.discussion.sort(function(a,b) {
            if(sortOrder === "newestFirst"){
                return (a.created < b.created) ? 1 : ((b.created < a.created) ? -1 : 0)
            }else{
                return (a.created > b.created) ? 1 : ((b.created > a.created) ? -1 : 0)
            }
        } ).map((item, index) => {

        
            let tag = Object.keys(this.state.types).indexOf(item.questionType) > -1 ? this.state.types[item.questionType] : '';
            return (
                <div className={`comment-question ${this.state.openCommentId === item.id ? 'CommentsBoxVisible' : ''}`} key={index}>
                    <a href="#" className="toggleCommentBoxIcon" onClick={e => {
                                                    e.preventDefault();
                                                    this.setState({openCommentId: ''});
                                                }}><i className="zmdi zmdi-chevron-up"></i></a>
                    <div className="commenter-image">
                        <img src={this.renderUserImage(item.Profile)} />
                    </div>
                    <div className="comment-details">
                        <div className="clearfix">
                            <div className="pull-left">
                                <p className="font-700 font-14">
                                    {item.Profile ? item.Profile.name + ' ' + item.Profile.lname : '99Point9 User'}
                                    <span className="text-info"> {tag}</span>
                                </p>
                            </div>                                                    
                        </div>
                        <p>{item.content}</p>
                        <div className="clearfix">
                            <div className="pull-left">
                                <div className="comment-meta">
                                    <div className="comments-meta-wrap">
                                        <div className="comments-meta-item">
                                            <div className="">
                                                <a href="#" onClick={e => {
                                                    e.preventDefault();
                                                    this.setState({openCommentId: item.id});
                                                }} className="text-black onHoverWhite"> Reply ({item.DiscussionComment.length})</a>
                                            </div>
                                        </div>
                                        <div className="comments-meta-item">
                                            <div className="">
                                                <a href="#" className={(item.Like.filter(l => l.profileId == this.props.user.user.Profile.id).length > 0) ? "text-red" : "text-black"} onClick={(e) => {
                                                    e.preventDefault();
                                                    let existing = item.Like.filter(l => l.profileId == this.props.user.user.Profile.id);
                                                    if(existing.length > 0){
                                                        this.props.deleteLike(existing[0]);
                                                    }else {
                                                        this.postLike(item.id);
                                                    }
                                                }}> {item.Like.length} Likes</a>
                                            </div>
                                        </div>
                                        <div className="comments-meta-item">
                                            {item.Follow ? 
                                            <a href="#" className={(item.Follow.filter(l => l.profileId == this.props.user.user.Profile.id).length > 0) ? "text-red" : "text-black"} onClick={(e) => {
                                                e.preventDefault();
                                                let existing = item.Follow.filter(l => l.profileId == this.props.user.user.Profile.id);
                                                if(existing.length > 0){
                                                    this.props.deleteFollow(existing[0]);
                                                }else {
                                                    this.postFollow(item.id);
                                                }
                                            }}
                                            >{(item.Follow.filter(l => l.profileId == this.props.user.user.Profile.id).length > 0) ? "Unfollow" : "Follow"}</a>
                                            : null }
                                        </div>
                                        <div className="comments-meta-item">
                                            <span className="font-12">Updated {moment(item.created).fromNow()} </span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            
                        </div>
                        <div className={`comments-on-comment ${this.state.openCommentId === item.id ? 'animated slideInUp' : ''}`} style={{display: "none"}}>
                            <div className="row">
                                <div className="col-sm-12">
                                    <textarea className="form-control h-100" rows="2" placeholder="Add your reply!" value={this.state.replyContent}
                                                      onChange={(e) => this.setState({replyContent: e.target.value})} />
                                </div>
                                <div className="col-sm-12">
                                    <div className="sm-top10">
                                    <input type="submit" value="Reply" className="btn btn-default"  onClick={(e) => this.postComment()} />
                                </div>
                                </div>
                            </div>
                            
                            {item.DiscussionComment.map((comment, i) => this.renderCommentComment(comment, i))}
                            
                           
                            
                        </div>
                    </div>
                </div>    
            )
        })
        }else{
            return (
                <div className="no-comments">
                    {this.state.questionTypeFilter === '' &&
                        <span>Have a question? Start a conversation!</span>
                    }
                    
                    {this.state.questionTypeFilter === 'Rudimentary' &&
                        <span>No one has asked a lecture question yet.</span>
                    }
                    
                    {this.state.questionTypeFilter === 'Conceptual' &&
                        <span>No one has asked a conceptual question yet.</span>
                    }
                    
                    {this.state.questionTypeFilter === 'Advanced' &&
                        <span>No one has asked a general question yet.</span>
                    }
                    
                    {this.state.questionTypeFilter === 'General' &&
                        <span>No one has asked a general question yet.</span>
                    }
                
                </div>    
            )
        }
        
    }

    renderCommentQuestionsOld = () => {
        return this.state.discussion.sort(function(a,b) {
            return (a.created < b.created) ? 1 : ((b.created < a.created) ? -1 : 0)
        } ).map((item, index) => {

            return (
                <div  className={`comment-question ${this.state.openCommentId === item.id && 'CommentsBoxVisible'}`} key={index}>
                    <div className="commenter-image">
                        <img src={this.renderUserImage(item.Profile)} />
                    </div>
                    <div className="comment-details">
                        <div className="clearfix">
                            <div className="pull-left">
                                <p className="font-700 font-14">{item.Profile ? item.Profile.name : ''} <span className="text-info"> {item.questionType}</span></p>
                            </div>
                            <div className="pull-right">
                                <p className="text-muted font-12">Updated {moment(item.created).fromNow()}</p>

                            </div>

                        </div>
                        <p>{item.content}</p>
                        <div className="clearfix">
                            <div className="pull-left">
                                <div className="comment-meta">
                                    <div className="clearfix">
                                        <div className="sm-top10 pull-left">
                                            <input type='checkbox' className='ios8-switch checkbox_with_label' id='follow_question' />
                                                <label for="follow_question">Follow</label>
                                        </div>
                                        <div className="pull-left">
                                            <div className="sm-top10 sp-left20">
                                                <a onClick={() => this.openComments(item.id)} className="text-black"><i className="zmdi zmdi-comment-alt"></i> {item.DiscussionComment.length}</a>
                                            </div>
                                        </div>
                                        <div className="pull-left">
                                            <div className="sm-top10 sp-left20">
                                                <a onClick={() => {
                                                    let existing = item.Like.filter(l => l.profileId == this.props.user.user.Profile.id);
                                                    if(existing.length > 0){
                                                        this.props.deleteLike(existing[0]);
                                                    }else {
                                                        this.postLike(item.id);
                                                    }
                                                }}
                                                   className={(item.Like.filter(l => l.profileId == this.props.user.user.Profile.id).length > 0) ? "text-red" : "text-black"}><i className="zmdi zmdi-thumb-up"></i> {item.Like.length}</a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="pull-right">
                                <div className="sm-top10 sp-left20">
                                    <a className="text-muted" onClick={() => this.openComments(item.id)}><i className="zmdi zmdi-comment"></i> Reply</a>
                                    {this.props.isAdmin &&
                                    <a className="text-muted" onClick={() => this.props.deleteDiscussion(item.id, this.props.user.id)}><i className="zmdi zmdi-close"></i> Delete</a>
                                    }
                                </div>
                            </div>
                        </div>
                        <SlideDown className='my-dropdown-slidedown'>
                            {
                                this.state.openCommentId === item.id &&
                                <div className="comments-on-comment">
                                    <div className="row">
                                        <div className="col-sm-10">
                                            <textarea className="form-control" rows="2" placeholder="Add your reply!"
                                                      value={this.state.replyContent}
                                                      onChange={(e) => this.setState({replyContent: e.target.value})}
                                            />
                                        </div>
                                        <div className="col-sm-2">
                                            <input type="submit" value="Reply" className="btn btn-default" onClick={(e) => this.postComment()}/>
                                        </div>
                                    </div>
                                    {this.renderCommentsOnComment(item.DiscussionComment)}
                                </div>
                            }
                        </SlideDown>
                    </div>
                </div>
            )

            return (
                <div
                    key={index}
                    className={`comment-question ${this.state.openCommentId === item.id && 'CommentsBoxVisible'}`}
                >
                    <div className="commenter-image">
                        <img src={item.Profile.image}/>
                    </div>
                    <div className="comment-details">
                        <div className="clearfix">
                            <div className="pull-left">
                                <p className="font-700 font-14">
                                    {item.Profile.name}
                                    <span className="text-info">
                                        {` ${item.questionType}`}
                                    </span>
                                </p>
                            </div>
                            <div className="comment-meta pull-right">
                                <div className="clearfix">
                                    <div className="sm-top10 pull-left label-discussion">
                                        <input type="checkbox" className="ios8-switch checkbox_with_label" id={`follow_question_${item.id}`}/>
                                        <label htmlFor={`follow_question_${item.id}`}>Follow </label>
                                    </div>
                                    <div className="pull-left">
                                        <div className="sm-top10 sp-leftonclick20">
                                            <a
                                                className="text-black"
                                                onClick={() => this.openComments(item.id)}
                                            >
                                                <i className="zmdi zmdi-comment-alt"/>
                                                {` ${item.DiscussionComment.length}`}
                                            </a>
                                        </div>
                                    </div>
                                    <div className="pull-left">
                                        <div className="sm-top10 sp-left20">
                                            <a href="#" className="text-red">
                                                <i className="zmdi zmdi-thumb-up"/>
                                                {` ${item.likes.length}`}
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <p>
                            {item.content}
                        </p>
                        <div className="clearfix">
                            <div className="pull-left">
                                <p className="sm-top10 text-muted">
                                    {`Updated ${moment(item.created).fromNow()}`}
                                </p>
                            </div>
                            <div className="pull-right">
                                <div className="sm-top10 sp-left20">
                                    <a
                                        className="text-muted"
                                        onClick={() => this.openComments(item.id)}
                                    >
                                        <i className="zmdi zmdi-comment"/> Reply
                                    </a>
                                </div>
                            </div>
                        </div>
                        <SlideDown className='my-dropdown-slidedown'>
                            {
                                this.state.openCommentId === item.id &&
                                <div className="comments-on-comment">
                                    <div className="row">
                                        <div className="col-sm-10">
                                            <textarea className="form-control" rows="2" placeholder="Add your reply!"
                                                value={this.state.replyContent}
                                                      onChange={(e) => this.setState({replyContent: e.target.value})}
                                            />
                                        </div>
                                        <div className="col-sm-2">
                                            <input type="submit" value="Reply" className="btn btn-default" onClick={(e) => this.postComment()}/>
                                        </div>
                                    </div>
                                    {this.renderCommentsOnComment(item.DiscussionComment)}
                                </div>
                            }
                        </SlideDown>
                    </div>
                </div>
            )
        });
    };
    
    renderCommentComment = (item, index) => {
        return (
            <div className="comment-on-comment" key={index}>
                <div className="replyer-image">
                    <img src={this.renderUserImage(item.Profile)} />
                </div>
                <div className="reply-dets">
                    <p>{item.Profile ? item.Profile.name + ' ' + item.Profile.lname : '99Point9 User'} replied</p>
                    <p>{item.content}</p>
                    <p className="sm-top10 text-muted font-12">Replied {moment(item.created).fromNow()}</p>
                </div>
            </div>
            )
    }

    renderCommentsOnCommentOld = (comment) => {
        return comment.map((item) => {
            return (
                <div className="comment-on-comment">
                    <div className="replyer-image">
                        <img src={this.renderUserImage(item.Profile)}/>
                    </div>
                    <div className="reply-dets">
                        <p>
                            {`${item.Profile.name} replied`}
                        </p>
                        <p>
                            {item.content}
                        </p>
                        <p className="sm-top10 text-muted font-12">
                            {`Replied ${moment(item.created).fromNow()}`}
                            &nbsp;
                            {this.props.isAdmin &&
                            <a className="text-muted" onClick={() => this.props.deleteComment(item.id, this.props.user.id)}><i className="zmdi zmdi-close"></i> Delete</a>

                            }
                        </p>
                    </div>
                </div>
            )
        })
    };

    render() {
        return (
            <div className={`tab-pane ${(this.props.showByDefault) ? "active" : ""}`} id="video_discussion">
                <div className="discussion-wrap sm-top20">
    
                    {!this.props.isAdmin ?
                    
                    <div className="sp-40 bg-light-3 ">
    
                        <div className="sm-top10">
                            <div className="row">
                                <div className="col-sm-12">
                                    <div className="form-select-overlay">
                                        <select className="form-control" value={this.state.questionType} onChange={(e) => this.setState({questionType: e.target.value})}>
                                            <option value="">What's your question about? </option>
                                            <option value="Rudimentary">I am unclear about the lecture</option>
                                            <option value="Conceptual">I am unclear about a concept</option>
                                            <option value="Advanced">How do I apply this concept?</option>
                                            <option value="General">I have a general question</option>
                                        </select>
                                    </div>
                                    {this.state.questionTypeError ?
                                        <div className="text-danger">You must select a question type</div>
                                    : null}
                                </div>
                            </div>
                        </div>
                        <div className="sm-top10">
                            <textarea className="form-control h-120" rows="4" value={this.state.content} onChange={(e) => this.setState({content: e.target.value})} />
                            {this.state.questionError ?
                                <div className="text-danger">This field is required.</div>
                            : null}
                        </div>
                        <div className="sm-top10 text-right">
                            <button type="submit" className="btn btn-base" onClick={(e) => this.postDiscussion()}>Ask away! </button>
                        </div>
    
                    </div>
                    
                  
    
                        :
                        <div className="sp-20 bg-light-3">
    
                            <div className="sm-top10">
                                <div className="row">
                                    <div className="col-sm-12">
                                         <button className="btn btn-danger" onClick={() => this.props.deleteAll(this.props.chapterVideoId, this.props.user.id)}>Delete All</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    }
                    <div className="comments-questions">
                        <div className="question-filter">
                            <div className="row">
                                <div className="col-sm-4">
                                    <div className="sm-top10">
                                        <input type="checkbox" className="ios8-switch checkbox_with_label" id="show_all_my_questions" onChange={(e) => {
                                            if(e.target.checked){
                                                this.filterDiscussion("mine", "add");
                                            }else{
                                                this.filterDiscussion("mine", "remove");
                                            }
    
                                        }}/>
                                        <label htmlFor="show_all_my_questions">Show all of my questions and answers</label>
                                    </div>
    
                                </div>
                                <div className="col-sm-4">
                                    <div className="sm-top10">
                                        <input type="checkbox" className="ios8-switch checkbox_with_label" id="show_questions_with_no_answer" onChange={(e) => {
                                            this.filterDiscussion("nocomments", "");
                                        }}/>
                                        <label htmlFor="show_questions_with_no_answer">Show questions with no answers only</label>
                                    </div>
                                </div>
                                <div className="col-sm-4">
                                    <div className="sm-top10">
                                        <input type="checkbox" className="ios8-switch checkbox_with_label" id="show_instructors_answer" onChange={(e) => {
                                            this.filterDiscussion("instructor", "");
                                        }}/>
                                        <label htmlFor="show_instructors_answer">Show instructors comments only</label>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="sm-top-bottom20">
                            <div className="flex flex-justify-content-space-between flex-align-items-center">
                                <h3 className="font-30 text-white text-uppercase no-margin">Lecture Discussion</h3>
                                <div className="w-400">
                                    <div className="flex flex-align-items-center filtersDropDowns">
                                        <div>Sorted By: </div>
                                        <div className="dropdown sm-right10 sm-left10">
                                            <a href="#" data-toggle="dropdown" className="btn btn-default"><span>{this.state.sortOrder === "newestFirst" ? "Most Recent" : "Oldest First"} </span> &nbsp;<i className="zmdi zmdi-caret-down"></i></a>
                                            <ul className="dropdown-menu pull-right">
                                                <li><a href="#" onClick={e => {
                                                    e.preventDefault();
                                                    this.setState({sortOrder: 'newestFirst'});
                                                }}>Most Recent</a></li>
                                                <li><a href="#" onClick={e => {
                                                    e.preventDefault();
                                                    this.setState({sortOrder: 'oldestFirst'});
                                                }}>Least Recent</a></li>
                                            </ul>
                                        </div>
                                        <div className="dropdown">
                                            <a href="#" data-toggle="dropdown" className="btn btn-default">
                                            
                                            {this.state.questionTypeFilter === '' &&
                                                <span>All Question Types</span>
                                            }
                                            
                                            {this.state.questionTypeFilter === 'Rudimentary' &&
                                                <span>Lecture questions</span>
                                            }
                                            
                                            {this.state.questionTypeFilter === 'Conceptual' &&
                                                <span>Conceptual questions</span>
                                            }
                                            
                                            {this.state.questionTypeFilter === 'Advanced' &&
                                                <span>Application questions</span>
                                            }
                                            
                                            {this.state.questionTypeFilter === 'General' &&
                                                <span>General questions</span>
                                            }
                                            
                                            
                                            &nbsp; <i className="zmdi zmdi-caret-down"></i></a>
                                            <ul className="dropdown-menu pull-right">
                                                <li><a href="#" onClick={e => {
                                                    e.preventDefault();
                                                    this.typeFilter('');
                                                }}>All Question Types</a></li>
                                                <li><a href="#" onClick={e => {
                                                    e.preventDefault();
                                                    this.typeFilter('Rudimentary');
                                                }}>Lecture questions </a></li>
                                                <li><a href="#" onClick={e => {
                                                    e.preventDefault();
                                                    this.typeFilter('Conceptual');
                                                }}>Conceptual questions </a></li>
                                                <li><a href="#" onClick={e => {
                                                    e.preventDefault();
                                                    this.typeFilter('Advanced');
                                                }}>Application questions </a></li>
                                                <li><a href="#" onClick={e => {
                                                    e.preventDefault();
                                                    this.typeFilter('General');
                                                }}>General questions</a></li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                                
                                
                            </div>
                        </div>
                        
                        {
                            this.state.discussion &&
                            this.renderCommentQuestions()}
    
                    </div>
                </div>
            </div>
        )
    }
}

export default VideoDiscussion;


// WEBPACK FOOTER //
// ./src/components/Video/VideoDiscussion.js